import React from 'react'
import {
	FormOutlined,
	QuestionCircleOutlined,
	DeploymentUnitOutlined,
} from '@ant-design/icons'
import { LogicalTopologyPage, GlossaryPage, DefinitionPage } from '../../pages'

const prefix = ''
export default {
	prefix,
	subRoutes: [
		{
			path: prefix + '/definición',
			exact: true,
			page: <DefinitionPage />,
			menuItemText: 'Definición',
			icon: <FormOutlined style={{ fontSize: '1rem' }} />,
		},
		{
			path: prefix + '/topología-lógica',
			exact: true,
			page: <LogicalTopologyPage />,
			menuItemText: 'Topología Lógica',
			icon: <DeploymentUnitOutlined style={{ fontSize: '1rem' }} />,
		},
		{
			path: prefix + '/glosario',
			exact: true,
			page: <GlossaryPage />,
			menuItemText: 'Glosario',
			icon: <QuestionCircleOutlined style={{ fontSize: '1rem' }} />,
		},
	],
}
